/*
 *  *
 *  *  * Copyright (c) 2023 Hg Digital, Setera
 *  *  *************************************************************
 *  *  *Projeto  : setera-web
 *  *  *Autor    : diegobrock
 *  *  *Data     : 05/07/2023 10:26
 *  *  *Empresa  : HG Digital/Setera
 *  *  *************************************************************
 *  *
 */

import { Injectable } from "@angular/core";
import { HateoasBaseService } from "./hateoas-base.service";
import { environment } from "../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { HttpUtil } from "../utils/http-util";
import { Observable } from "rxjs";
import { Transporter } from "../models/transporter.model";
import { toSnake } from "snake-camel";
import { PageEvent } from "@angular/material/paginator";

@Injectable({
  providedIn: "root",
})
export class TransporterService extends HateoasBaseService {
  // tslint:disable-next-line:variable-name
  private _httpUtil: HttpUtil;
  private resourceName = "transporters";

  constructor(http: HttpClient, httpUtil: HttpUtil) {
    super(http, httpUtil);
    this._httpUtil = httpUtil;
  }

  public save(transporter: Transporter): Observable<any> {
    const transporterSnake = toSnake(transporter);
    return this.executeActionOnResource(
      this.resourceName,
      "save",
      null,
      transporterSnake,
      null
    );
  }

  public update(transporter: Transporter, uuid: string): Observable<any> {
    const transporterSnake = toSnake(transporter);
    const params = new Map<string, string>();
    params.set("uuid", uuid);
    return this.executeActionOnResource(
      this.resourceName,
      "update",
      null,
      transporterSnake,
      params
    );
  }
  public getAll(page: PageEvent, name: string): Observable<any> {
    const direction = "ASC";
    const params = this._httpUtil.buildPaginator(page, direction);
    if (name !== undefined && name !== null && name.length > 0) {
      params.set("name", name);
    }
    return this.executeActionOnResource(
      this.resourceName,
      "get-all",
      null,
      null,
      params
    );
  }

  public delete(uuid: string): Observable<any> {
    const params = new Map<string, string>();
    params.set("uuid", uuid);
    return this.executeActionOnResource(
      this.resourceName,
      "delete-by-uuid",
      null,
      null,
      params
    );
  }
  public getByUuid(uuid: string): Observable<any> {
    const params = new Map<string, string>();
    params.set("uuid", uuid);
    return this.executeActionOnResource(
      this.resourceName,
      "get-by-uuid",
      null,
      null,
      params
    );
  }

  public search(userId: number): Observable<any> {
    const params = new Map<string, string>();
    params.set("user_id", String(userId));
    return this.executeActionOnResource(
      this.resourceName,
      "search",
      null,
      null,
      params
    );
  }

  protected getApiBaseUrl(): string {
    return environment.apisConfig.seteraFleetApi.apiBaseUrl;
  }

  protected getMicroServiceBaseUrl(): string {
    return environment.apisConfig.seteraFleetApi.microServiceBaseUrl;
  }
}
